// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLightBulb1_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17 2H15V7H17V2ZM32 19H27V17H32V19ZM5 17V19H0V17H5ZM20 30V28H12V30H20Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M20 25.0018C22.6779 23.571 24.5 20.7483 24.5 17.4999C24.5 12.8055 20.6944 8.99994 16 8.99994C11.3056 8.99994 7.5 12.8055 7.5 17.4999C7.5 20.7483 9.32211 23.571 12 25.0018V26H20V25.0018ZM22.5 17.4999C22.5 21.0898 19.5899 23.9999 16 23.9999C12.4101 23.9999 9.5 21.0898 9.5 17.4999C9.5 13.9101 12.4101 10.9999 16 10.9999C19.5899 10.9999 22.5 13.9101 22.5 17.4999Z" class="svg-bg"/>
  <path d="M5.39331 5.97925 8.92884 9.51478 7.51463 10.929 3.9791 7.39346 5.39331 5.97925ZM26.6063 5.97911 23.0708 9.51465 24.485 10.9289 28.0205 7.39333 26.6063 5.97911Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.4141 21.554H17.0001V13.5H15.7103L13.2278 15.4653L14.0468 16.4793L15.0037 15.7138C15.1307 15.6165 15.2471 15.5153 15.3525 15.4099C15.3844 15.3802 15.4148 15.3516 15.4436 15.3243C15.436 15.4782 15.4298 15.6396 15.4251 15.8082C15.4177 16.073 15.4141 16.3233 15.4141 16.559V21.554Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLightBulb1 is a generated icon component.
 */
let IconMedLightBulb1 = IconMedLightBulb1_1 = class IconMedLightBulb1 extends IconBaseElement {
    render() {
        return html `${IconMedLightBulb1_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLightBulb1.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconMedLightBulb1 = IconMedLightBulb1_1 = __decorate([
    customElement('zui-icon-med-light-bulb-1')
], IconMedLightBulb1);
export { IconMedLightBulb1 };
